import { render, staticRenderFns } from "./CustomersList.html?vue&type=template&id=2d4b95be&scoped=true&"
import script from "./CustomersList.js?vue&type=script&lang=js&"
export * from "./CustomersList.js?vue&type=script&lang=js&"
import style0 from "./CustomersList.scss?vue&type=style&index=0&id=2d4b95be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b95be",
  null
  
)

export default component.exports